import React, { useState, useEffect } from "react";
import GroupColumn from './GroupColumn';
import { DragDropContext } from 'react-beautiful-dnd';

const GroupBoard = (props) => {

    const { dataBoard } = props
    const [board, setBoard] = useState(dataBoard)

    useEffect(() => {
        setBoard(dataBoard);
    }, [dataBoard])

    const onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        // there is no destination
        if (!destination)
            return;

        // source and destination are the same
        if (destination.droppableId === source.droppableId && destination.index === source.index)
            return;

        const columnS = board.columns[source.droppableId];
        const columnD = board.columns[destination.droppableId];

        // if source and destination belong to same column
        if (source.droppableId === destination.droppableId) {
            const cards = columnS.cards;
            const card = cards.find(item => item.id === draggableId);
            cards.splice(source.index, 1);
            cards.splice(destination.index, 0, card);

            board.columns[source.droppableId].cards = cards;
            setBoard(board);

            return;
        }

        // if source and destination belong to different columns
        const cardsS = columnS.cards;
        const card = cardsS.find(item => item.id === draggableId);
        const cardsD = columnD.cards;

        cardsS.splice(source.index, 1);
        cardsD.splice(destination.index, 0, card)

        board.columns[source.droppableId].cards = cardsS;
        board.columns[destination.droppableId].cards = cardsD;
        props.setDataBoard(board);

        return;
    }

    const myBoard = board.columnsId.map((columnId, i) => {
        const column = board.columns[columnId];
        return <GroupColumn key={columnId} column={column} />
    })

    return (
        <DragDropContext
            onDragEnd={onDragEnd}
        >
            <div className="row w-100 m-0 mt-2 mr-n1 ml-n1">
                {myBoard}
            </div>
        </DragDropContext>
    )
}

export default GroupBoard;